__turbopack_context__.v({
  "active_tab": "GalleryComponent-module-scss-module__6OoIWa__active_tab",
  "close_button": "GalleryComponent-module-scss-module__6OoIWa__close_button",
  "gallery_card_img": "GalleryComponent-module-scss-module__6OoIWa__gallery_card_img",
  "gallery_card_img_parent": "GalleryComponent-module-scss-module__6OoIWa__gallery_card_img_parent",
  "gallery_card_parent": "GalleryComponent-module-scss-module__6OoIWa__gallery_card_parent",
  "gallery_tab_bar": "GalleryComponent-module-scss-module__6OoIWa__gallery_tab_bar",
  "l27": "GalleryComponent-module-scss-module__6OoIWa__l27",
  "loader": "GalleryComponent-module-scss-module__6OoIWa__loader",
  "loading": "GalleryComponent-module-scss-module__6OoIWa__loading",
  "modal_overlay": "GalleryComponent-module-scss-module__6OoIWa__modal_overlay",
  "next_button": "GalleryComponent-module-scss-module__6OoIWa__next_button",
  "overlay": "GalleryComponent-module-scss-module__6OoIWa__overlay",
  "prev_button": "GalleryComponent-module-scss-module__6OoIWa__prev_button",
  "skeleton": "GalleryComponent-module-scss-module__6OoIWa__skeleton",
  "video_wrapper": "GalleryComponent-module-scss-module__6OoIWa__video_wrapper",
});
